module.exports = __webpack_public_path__ + "kh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/kh.svg
// module id = 890
// module chunks = 0